import { render, staticRenderFns } from "./AddressRequirementsBreakDialog.vue?vue&type=template&id=ba6e27fa&scoped=true&lang=pug&"
import script from "./AddressRequirementsBreakDialog.vue?vue&type=script&lang=ts&"
export * from "./AddressRequirementsBreakDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6e27fa",
  null
  
)

export default component.exports